export default __webpack_public_path__ + "static/media/744.d9943946.gif";